import {
    ButtonBase,
    Drawer,
    makeStyles,
    TextField,
    Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import COLORS from 'src/lib/colors';

interface GetCodeProps {
    openDrawer: boolean;
    error: boolean;
    handleCloseDrawer: () => void;
    handleAllSet: () => void;
    inputValue: string;
}

const useStyles = makeStyles({
    otpForm: {
        '& .MuiTextField-root': {
            width: '100%',
        },
        '& .MuiInput-underline:after': {
            display: 'none',
        },
        '& .MuiInput-underline:before': {
            display: 'none',
        },
        '& .Mui-error > input': {
            margin: '15px 0 0 0',
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#000000 !important',
            fontWeight: '700',
        },
    },
    ctaBtn: {
        height: '50px',
        borderRadius: '1.885rem',
        background: COLORS.brandRed,
        color: COLORS.whiteSmoke,
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        margin: '20px 0 0 0',
        width: '100%',
        '&:hover': {
            backgroundColor: COLORS.brandRed,
        },
        '&:active': {
            backgroundColor: COLORS.brandRed,
        },
    },
    exitContainer: {
        height: '450px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '24px',
        position: 'relative',
        '& > span': {
            background: '#D9D9D9',
            width: '50px',
            height: '3px',
            position: 'absolute',
            borderRadius: '5px',
            top: '5px',
        },
    },
    ctwText: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '28px',
        color: '#000000',
        padding: '50px 30px 30px',
        background: '#F2F3F4',
        width: '100%',
    },
    tacoext: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        color: '#000000',
        padding: '30px',
    },
    paperDrawer: {
        borderRadius: ' 15px 15px 0px 0px',
    },
    otpInput: {
        '& .MuiInputBase-input': {
            border: '1px solid rgba(0, 0, 0, 0.2)',
            width: '100%',
            borderRadius: ' 15px',
            minHeight: '70px',
            margin: '15px 0',
            fontSize: '32px',
            lineHeight: '24px',
            letterSpacing: '20px',
            padding: '0 28px',
            textAlign: 'center',
        },
    },
    smallTxt: {
        fontSize: '12px',
        lineHeight: '16px',
        padding: '10px 0',
        textAlign: 'center',
    },
});

const GetCodeDrawer = ({
    openDrawer,
    handleCloseDrawer,
    inputValue,
    handleAllSet,
    error,
}: GetCodeProps) => {
    const classes = useStyles();

    return (
        <>
            <Drawer
                anchor="bottom"
                open={openDrawer}
                onClose={handleCloseDrawer}
                classes={{
                    paper: classes.paperDrawer,
                }}
                style={{ borderRadius: ' 15px 15px 0px 0px' }}
            >
                <div className={classes.exitContainer}>
                    <span />
                    <Typography className={classes.ctwText}>
                        Let's make sure we're accessing the right account
                    </Typography>
                    <Typography className={classes.tacoext}>
                        <div>
                            Please provide the following single use code when
                            prompted by a Staples Associate
                        </div>
                        <form className={classes.otpForm}>
                            <TextField
                                id="otp-input"
                                className={classes.otpInput}
                                disabled
                                autoFocus
                                inputProps={{ maxLength: 6 }}
                                value={inputValue}
                                //   onChange={(e) => setInputValue(e.target.value)}
                                error={error}
                                helperText={
                                    error ? 'Please enter a 6-digit value' : ''
                                }
                            />
                            <Typography className={classes.smallTxt}>
                                This code is valid for 15 minutes
                            </Typography>
                            <ButtonBase
                                className={classes.ctaBtn}
                                onClick={handleAllSet}
                            >
                                <span>All set</span>
                            </ButtonBase>
                        </form>
                    </Typography>
                </div>
            </Drawer>
        </>
    );
};

export default GetCodeDrawer;
